import React, { useEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { ThemeProvider as MaterialThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import DefaultTheme from 'themes/default';
import { AppStoreState } from 'types';

const defaultTheme = DefaultTheme;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ThemeContext = React.createContext<any>(null);

type Props = {
  children: any;
};

export const ThemeProvider = (props: Props) => {
  const [theme, setTheme] = useState(defaultTheme);
  const workbooks = useSelector(({ entity }: AppStoreState) => entity.workbooks, shallowEqual);
  const currentWorkbook: any = useSelector(
    ({ app }: AppStoreState) => app.currentWorkbook,
    shallowEqual
  );

  useEffect(() => {
    if (currentWorkbook) {
      const clonedTheme = defaultTheme;
      clonedTheme.palette.primary.main = currentWorkbook?.primaryColor;
      clonedTheme.palette.primary.light = currentWorkbook?.secondaryColor;
      clonedTheme.palette.primary.contrastText = currentWorkbook?.textColor;
      /*
          NOTE: returning a new object here to trigger re-renders to solve all stale theme issues; while this is not the
                material-ui recommended approach, we only refresh the theme on workbook change, so performance is not a concern
        */
      setTheme({ ...clonedTheme });
    }
  }, [workbooks, setTheme, currentWorkbook]);

  return (
    <ThemeContext.Provider value={theme}>
      <MaterialThemeProvider theme={theme}>
        <StyledEngineProvider injectFirst>{props.children}</StyledEngineProvider>
      </MaterialThemeProvider>
    </ThemeContext.Provider>
  );
};
